import { SelectableIconCard } from '@juvare/common-web-ui/Cards/SelectableIconCard';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { formatDate } from '@juvare/common-web-ui/utils';
import { Badge, Box, Typography } from '@mui/material';
import { parseISO } from 'date-fns';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
import { AlertIcon } from '../../../../alerts/components/AlertIcon/AlertIcon';
export const NotificationCard = ({ notification, checked, selected, onCardClick, onIconClick }) => {
    var _a, _b;
    const { t } = useAlertUiTranslation();
    const dateTime = notification.received;
    const user = (_b = (_a = notification.sender) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : 'Unknown';
    const title = notification.subject;
    const content = (React.createElement(Box, { sx: {
            display: 'grid',
            gridTemplateRows: 'auto auto auto',
            gridTemplateColumns: '100%',
            px: 2,
            py: 2.7,
            backgroundColor: notification.read ? undefined : themeColors.primary.surface,
            '&:hover': notification.read
                ? undefined
                : {
                    backgroundColor: themeColors.accent.blue.alpha,
                    outline: selected ? '2px solid ' + themeColors.accent.blue.base : '1px solid ' + themeColors.accent.blue.base,
                },
        } },
        React.createElement(Typography, { variant: 'caption', sx: {
                color: themeColors.text.subtle,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            } },
            dateTime ? formatDate(parseISO(dateTime)) : '',
            " \u00A0\u25CF\u00A0 ",
            user),
        React.createElement(Box, { sx: { display: 'flex', gap: 1, alignItems: 'center' } },
            React.createElement(Typography, { variant: 'subtitle1', sx: {
                    width: 0,
                    flexGrow: 1,
                    color: themeColors.text.main,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                } }, title),
            !notification.read && React.createElement(Badge, { sx: { pl: 1 }, color: 'error', variant: 'dot' }))));
    return (React.createElement(SelectableIconCard, { checked: checked, selected: selected, icon: React.createElement(AlertIcon, null), color: 'blue', onCardClick: onCardClick, cardAriaLabel: (notification.read ? t('pages.tables.notificationRead', { title }) : t('pages.tables.notificationUnread', { title })) +
            ', ' +
            t('common.preview').toLowerCase(), onIconClick: onIconClick, iconAriaLabel: title, "data-test": 'notification-card' }, content));
};
